import { Observable } from 'rxjs';
import { AgendaResponse } from 'src/app/global/interfaces/agenda-response';


export abstract class AgendaServiceVM {

    abstract getAgenda(): Observable<AgendaResponse>;

    abstract postAgenda(agenda: any): Observable<any>;

    abstract formatFechas(fechas: any): any;

    abstract formatUnaFecha(fecha: any): any;

    abstract getAgendaSinFormato(): Promise<any>;
}
